<nb-accordion *ngIf="forexData.length" class="request-accordion">
  <nb-accordion-item class="request-list-container">
    <nb-accordion-item-header>
      <div class="request-list" fxLayout="row">
        <div class="request-title">
          <span>{{ forexHeading }}</span>
          <span style="margin-left: 4px;">({{forexData.length}})</span>
        </div>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body class="innerItems">
      <ng-container *ngFor="let item of forexData; let i = index">
        <div class="forex-content" class="approval-box" >
        <div class="status">
          <span class="item-status">Status:</span>
          <span class="status-highlight text-space">Pending with F&A Team</span>
        </div>
        <span class="approval-count">Approval : {{ i + 1 }}</span>
        <hr class="divider" />

        <div class="data-card">
          <div class="data-row">
            <div class="row-data">Employee Name:</div>
            <div class="item-data">{{ item?.employeename }}</div>
          </div>

          <div class="data-row">
            <div class="row-data">Employee Mail ID:</div>
            <div class="item-data email">{{item?.employeeemailid}}</div>
          </div>

          <div class="data-row">
            <div class="row-data">Forex Request Date:</div>
            <div class="item-data">{{item?.forexrequestdatebyemployee | date:'dd-MMM-yy'}}</div>
          </div>

          <div class="data-row">
            <div class="row-data">City:</div>
            <div class="item-data">{{item?.city}}</div>
          </div>
        
        <div class="buttonSection" fxLayoutAlign="center">
          <button class="approveBtn" (click)="viewMore(item)">
             <img src="assets/images/arrow-approve.svg" class="" alt="approve" />
          </button>
        </div>

        </div>
       
      </div>
      </ng-container>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>